@if (data) {
  <p>
    @if (data.icon) {
      <icon class="DataGrid__Icon" [name]="data.icon"></icon>
    } @else {
      <span
        class="DataGrid__TextWithIcon"
        [ngStyle]="{ 'background-color': data.color }"
      ></span>
    }
    <span
      class="DataGrid__Text"
      [ngClass]="{ 't-bold': isTextBold }"
      [innerHTML]="data.value || '-'"
    ></span>
  </p>
}
